/**
 * Coordinator Style01 - Stitch v1: glass, hub icon, Online/Offline status
 */
import type { TraitControlProps } from './types'
import { getTraitConfig } from './traitStyleConfig'
import './CoordinatorStyle01.css'

export function CoordinatorStyle01({ state }: TraitControlProps) {
  const { icon } = getTraitConfig('Coordinator')
  const status = (state?.status ?? state?.online ?? state?.connected) as boolean | string | undefined
  const isOnline = status === true || status === 'online' || status === 'connected' || String(status).toLowerCase() === 'true'

  return (
    <div className="trait-coordinator-style01 trait-stitch-glass">
      <div className="trait-coordinator-style01__header">
        <span className="trait-coordinator-style01__title">Coordinator</span>
        <span className={`material-symbols-outlined trait-coordinator-style01__icon`}>{icon}</span>
      </div>
      <div className="trait-coordinator-style01__status">
        <span className={`material-symbols-outlined trait-coordinator-style01__status-icon ${isOnline ? 'online' : ''}`}>
          hub
        </span>
        <span className="trait-coordinator-style01__status-text">{isOnline ? 'Online' : 'Offline'}</span>
      </div>
    </div>
  )
}
